var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useEffect, useCallback } from "react";
import Icon from "@mdi/react";
import { mdiArrowUp } from "@mdi/js";
import styled from "styled-components";
var Button = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: fixed;\n  right: 55px;\n  z-index: 991;\n  bottom: 55px;\n  background: #000;\n  color: #fff;\n  border-radius: 0;\n  opacity: 0;\n  border: none;\n  transition: opacity 0.25s ease, transform 0.25s ease;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  &:hover,\n  &:focus {\n    box-shadow: 0 5px 20px -8px #000000aa !important;\n  }\n\n  @media only screen and (max-width: 768px) {\n    right: 20px;\n  }\n"], ["\n  position: fixed;\n  right: 55px;\n  z-index: 991;\n  bottom: 55px;\n  background: #000;\n  color: #fff;\n  border-radius: 0;\n  opacity: 0;\n  border: none;\n  transition: opacity 0.25s ease, transform 0.25s ease;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  &:hover,\n  &:focus {\n    box-shadow: 0 5px 20px -8px #000000aa !important;\n  }\n\n  @media only screen and (max-width: 768px) {\n    right: 20px;\n  }\n"])));
var ScrollToButton = function () {
    var showButton = useCallback(function () {
        var scrollTop = document.body.getBoundingClientRect().top, button = document.querySelector("#scroll-up");
        if (button) {
            if (scrollTop < -50) {
                button.style.opacity = "1";
            }
            else {
                button.style.opacity = "0";
            }
        }
    }, []);
    // animate in scroll up button
    useEffect(function () {
        showButton();
        window.addEventListener("scroll", function () {
            showButton();
        });
        return function () {
            window.removeEventListener("scroll", function () {
                showButton();
            });
        };
    }, []);
    var scrollToTop = function (e) {
        window.scroll({ top: 0, behavior: "smooth" });
        e.target.blur();
    };
    return (React.createElement(Button, { id: "scroll-up", className: "btn btn-animate-up btn-box", onClick: scrollToTop },
        React.createElement(Icon, { path: mdiArrowUp, size: 0.85, color: "#fff" })));
};
export default ScrollToButton;
var templateObject_1;
